import { Box, Divider, Skeleton, Typography } from "@mui/material";
import type { JSX, ReactNode } from "react";

interface PriceCardProps {
  title: string;
  titleAdornment?: ReactNode;
  hint?: string;
  hintContent?: ReactNode;
  isHintLoading?: boolean;
  children?: ReactNode;
  footer?: ReactNode;
  sx: object;
}

export const PriceCard = ({
  title,
  titleAdornment,
  hint,
  hintContent,
  isHintLoading = false,
  children,
  footer,
  sx,
}: PriceCardProps): JSX.Element => {
  return (
    <Box sx={sx}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: titleAdornment ? "minmax(0, 1fr) auto" : "1fr",
          alignItems: "start",
          gap: "8px",
          width: "100%",
          minHeight: "24px",
        }}
      >
        <Typography
          sx={{
            minWidth: 0,
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
          }}
        >
          {title}
        </Typography>
        {titleAdornment && <Box sx={{ alignSelf: "start" }}>{titleAdornment}</Box>}
      </Box>
      {children}
      {isHintLoading ? (
        <Skeleton animation="wave" variant="rounded" width={90} height={16} />
      ) : (
        hintContent ?? <Typography variant="hintText">{hint}</Typography>
      )}
      {footer && (
        <>
          <Divider sx={{ width: "100%" }} />
          {footer}
        </>
      )}
    </Box>
  );
};
